import tyreStack from "../images/tyre-stack.png"
import { ImWhatsapp, ImCalendar } from "react-icons/im";
import '../App.css';

function Hero() {
    return (
        <div className="hero justify-start text-white font-rescue italic">
        <div className="flex flex-row items-center image-bg">
          {/* <img
            src={heroImage}
            className="max-w-sm rounded-lg shadow-2xl" /> */}
          <div className="flex flex-col items-center text-center p-20 font-bold w-full md:w-1/2">
            {/* <img
            src={logo}
            className="max-w-sm rounded-lg shadow-2xl mt-10" /> */}
            <h1 className="text-2xl md:text-4xl">Rescue Tyres LTD</h1>
            <h1 className="text-md md:text-lg py-6 text-rescueRed">
            Expert Solutions for All Your Tyre Needs.
            </h1>
            <div className="flex flex-col md:flex-row gap-2">
            <a href="/book" className="btn text-center md:w-1/2 !text-white bg-rescueRed hover:!text-rescueRed hover:bg-white"><ImCalendar /><span>Book Now</span></a>
            <a href="https://wa.me/447473720871" className="btn text-center md:w-1/2 !text-white bg-whatsapp hover:!text-whatsapp hover:bg-white"><ImWhatsapp /><span>Whatsapp</span></a>
            </div>
          </div>
          <div className="hidden md:flex md:flex-row md:justify-end md:p-10 md:text-center md:font-bold md:w-1/2">
            <img
            src={tyreStack}
            className="max-w-sm" 
            alt="hero tyre stack"
            />
          </div>
        </div>
      </div>
  );
}

export default Hero;
